import React, { useState, useEffect } from "react";
import "./App.css";
import { Toaster } from "sonner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import BiographySection from "./components/BiographySection";
import ServicesSection from "./components/ServicesSection";
import WhyChooseSection from "./components/WhyChooseSection";
import PartnersSection from "./components/PartnersSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import AdminPage from "./pages/AdminPage";
import AdminLogin from "./pages/AdminLogin";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function App() {
  const [showAdmin, setShowAdmin] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [checkingAuth, setCheckingAuth] = useState(false);

  // Check URL for admin access
  useEffect(() => {
    const checkAdminRoute = () => {
      if (window.location.hash === '#admin' || window.location.pathname === '/admin') {
        setShowAdmin(true);
      }
    };
    checkAdminRoute();
    window.addEventListener('hashchange', checkAdminRoute);
    return () => window.removeEventListener('hashchange', checkAdminRoute);
  }, []);

  // Check existing session on mount
  useEffect(() => {
    const checkSession = async () => {
      setCheckingAuth(true);
      try {
        const response = await fetch(`${API_URL}/api/auth/me`, {
          credentials: 'include'
        });
        if (response.ok) {
          setIsAuthenticated(true);
        }
      } catch (error) {
        // Not authenticated
      } finally {
        setCheckingAuth(false);
      }
    };
    checkSession();
  }, []);

  const handleBackFromAdmin = () => {
    setShowAdmin(false);
    window.history.pushState({}, '', '/');
  };

  const handleLogin = (success) => {
    if (success) {
      setIsAuthenticated(true);
    }
  };

  const handleLogout = async () => {
    try {
      await fetch(`${API_URL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include'
      });
    } catch (error) {
      // Continue with logout even if request fails
    }
    setIsAuthenticated(false);
    setShowAdmin(false);
    window.history.pushState({}, '', '/');
  };

  if (showAdmin) {
    if (checkingAuth) {
      return (
        <div className="min-h-screen bg-stone-100 flex items-center justify-center">
          <p className="text-stone-500">Chargement...</p>
        </div>
      );
    }
    if (!isAuthenticated) {
      return (
        <>
          <Toaster position="top-center" richColors />
          <AdminLogin onLogin={handleLogin} onBack={handleBackFromAdmin} />
        </>
      );
    }
    return (
      <>
        <Toaster position="top-center" richColors />
        <AdminPage onBack={handleBackFromAdmin} onLogout={handleLogout} />
      </>
    );
  }

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <HeroSection />
        <BiographySection />
        <ServicesSection />
        <WhyChooseSection />
        <PartnersSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
